var exports = {
  "kL": "x93eb46d8--d079ce--container",
  "Wf": "x93eb46d8--d079ce--rounded",
  "mc": "x93eb46d8--d079ce--middle",
  "as": "x93eb46d8--d079ce--large",
  "n2": "x93eb46d8--d079ce--extra-large",
};

module.exports = exports;
